import * as React from 'react'
import dayjs from 'dayjs'
import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  IconButton,
  Paper,
  TextField,
  Typography
} from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { createEffect } from 'effector'
import { useStore } from 'effector-react'
import { $userSearch, searchUserFx } from '../../Api/userSearch'
import { useForm } from 'react-hook-form'
import { Link, useNavigate } from 'react-router-dom'
import { updateModal } from '../../components/ErrorModal'
import api from '../../Auth/api'
import debounce from 'lodash/debounce'
import { BlockTitle } from '../../components/UI/BlockTitle/BlockTitle'

export default function ReplacementsPage() {
  const navigate = useNavigate()
  const createUserReplacementFx = createEffect(async (data) => {
    api.put(`replacement`, data).then(
      () => navigate('/replacements'),
      (error) => updateModal(error.response.data.errors)
    )
  })
  const [newUser, setNewUser] = React.useState()
  const [oldUser, setOldUser] = React.useState()
  const [dateFrom, setDateFrom] = React.useState(dayjs()?.format('YYYY-MM-DD'))
  const [dateTo, setDateTo] = React.useState(
    dayjs().add(1, 'month')?.format('YYYY-MM-DD')
  )
  const usersTable = useStore($userSearch)
  const searchUser = React.useCallback(
    debounce((event, value) => {
      searchUserFx(value)
    }, 200),
    []
  )
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm()

  const onSubmit = () => {
    const from = dateFrom
    const to = dateTo
    const data = {
      userId: oldUser?.id,
      replacerId: newUser?.id,
      startsAt: from,
      endsAt: to
    }
    createUserReplacementFx(data)
  }
  const loading = usersTable.length === 0
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Paper
          sx={{ padding: '1rem', borderRadius: '1rem', mt: 3 }}
          elevation={0}
        >
          <BlockTitle backUrl="/replacements" label="Замещения" />
          <Box display="flex" flexDirection="column" mt={3}>
            <Typography pr={2} variant="subtitle2" mb={2}>
              Период действия:
            </Typography>
            <Box display="flex" alignItems="center">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  inputFormat="DD.MM.YYYY"
                  label="От"
                  value={dateFrom}
                  onChange={(newValue) => {
                    setDateFrom(newValue?.format('YYYY-MM-DD'))
                  }}
                  renderInput={(params) => (
                    <TextField {...params} {...register('date_begin')} />
                  )}
                />
              </LocalizationProvider>
              <Typography pr={2} pl={2} variant="subtitle2">
                -
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  inputFormat="DD.MM.YYYY"
                  label="До"
                  value={dateTo}
                  onChange={(newValue) => {
                    setDateTo(newValue?.format('YYYY-MM-DD'))
                  }}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </Box>
          </Box>
          <Box display="flex" flexDirection="row" alignItems="center" mt={4}>
            <Typography
              display="flex"
              justifyContent="center"
              pr={2}
              variant="subtitle2"
            >
              Кого замещает:
            </Typography>
            <FormControl sx={{ m: 1, minWidth: 300 }}>
              <Autocomplete
                id="tags-standard"
                options={usersTable}
                loading={loading}
                value={oldUser || null}
                loadingText="Загрузка..."
                onInputChange={searchUser}
                onChange={(event, value) => setOldUser(value)}
                getOptionLabel={(option) => option?.name}
                isOptionEqualToValue={(option, value) => true}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    {...register('oldUser', { required: true })}
                  />
                )}
              />
            </FormControl>
          </Box>
          <Box display="flex" flexDirection="row" alignItems="center" mt={4}>
            <Typography
              display="flex"
              justifyContent="center"
              pr={2}
              variant="subtitle2"
            >
              Кто замещает:
            </Typography>
            <FormControl sx={{ m: 1, minWidth: 300 }}>
              <Autocomplete
                id="tags-standard"
                options={usersTable}
                loading={loading}
                value={newUser || null}
                loadingText="Загрузка..."
                onInputChange={searchUser}
                onChange={(event, value) => setNewUser(value)}
                getOptionLabel={(option) => option?.name}
                isOptionEqualToValue={(option, value) => true}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    {...register('newUser', { required: true })}
                  />
                )}
              />
            </FormControl>
          </Box>
          <Box
            display="flex"
            flexDirection="row"
            alignItems="center"
            mt={4}
            gap="20px"
          >
            <Link to="/replacements">
              <Button variant="outlined">Отмена</Button>
            </Link>
            <Button type="submit" variant="contained">
              Сохранить
            </Button>
          </Box>
        </Paper>
      </form>
    </>
  )
}
